import { defineComponent as _defineComponent } from 'vue'
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AzSearchItem',
  props: {
    link: null,
    name: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  link?: string | Record<string, any>;
  name?: string;
};





return { __sfc: true,props, emit, NuxtLinkCustom, AzIcon }
}

})